// extracted by mini-css-extract-plugin
module.exports = {"home-page":"home-page__2cgJr","body":"body__-ErE1","nav":"nav__20U3N","with-header":"with-header__1TU8F","main-pane":"main-pane__2idgN"};